export const titleize = (string) => _.kebabCase(string).split('-').map(_.capitalize).join(' ');
export const errorsToSentence = (response) => {
  if (!response?.data?.errors) return;

  const errorToString = (errors, field) => `${titleize(field)} ${_.join(errors, ' and ')}.`;
  return _.join(_.map(response.data.errors, errorToString), " ");
}